import { Badge, Input } from 'reactstrap';
import Tooltip from '@mui/material/Tooltip';

const RolePill = (props) => {
    if (props.roles.length > 0) {
        return (
            <div className='reclutamiento-list-buttons'>
                {props.roles.map((rol, index) => {
                    return (
                        <Tooltip title={rol.description ?? 'Rol'}>
                            <div className='reclutamiento-list-buttons-item'>
                                <Badge key={`badge_reclutamiento_${index}`} color="info" pill>
                                    {rol.name}
                                    <button className='add-role-button' onClick={() => {
                                        props.deleteRol(rol.id)
                                    }}>x</button>
                                </Badge>
                            </div>
                        </Tooltip>
                    )
                })}
                <Tooltip title={'Asignar rol'}>
                    <div className='reclutamiento-list-buttons-item'>
                        <Badge key={`badge_reclutamiento_new`} color="success" pill>
                            <button className='add-role-button' onClick={() => {
                                props.onClick()
                                }}>+</button>
                        </Badge>
                    </div>
                </Tooltip>
                {props.showList ? <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    onChange={(e) => props.addRole(e.target.value)}
                >
                    {props.listOfRoles.map((role) => {
                        if (role.name !== 'Metro_superadmin') return (<option>
                            {role.name}
                        </option>)
                    })}
                </Input> : <></>}
            </div>
        );
    }
    else {
        return <div className='ape-list-nodata-text'>
            <Tooltip title={'Asignar rol'}>
                <div className='reclutamiento-list-buttons-item'>
                    <Badge key={`badge_reclutamiento_new`} color="success" pill>
                        <button className='add-role-button' onClick={() => {
                            props.onClick()
                        }}>+</button>
                    </Badge>
                </div>
            </Tooltip>
            {props.showList ? <Input
                id="exampleSelect"
                name="select"
                type="select"
                onChange={(e) => props.addRole(e.target.value)}
            >
                {props.listOfRoles.map((role) => {
                    if (role.name !== 'Metro_superadmin') return (<option>
                        {role.name}
                    </option>)
                })}
            </Input> : <></>}
        </div>
    }
}

export default RolePill